import { render, staticRenderFns } from "./DocumentSelectDialog.vue?vue&type=template&id=4f53efd2&scoped=true&"
import script from "./DocumentSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSelectDialog.vue?vue&type=style&index=0&id=4f53efd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f53efd2",
  null
  
)

export default component.exports